module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"votedplayers":"Voted players"},"fi":{"votedplayers":"Äänestäneet pelaajat"},"sv":{"votedplayers":"Röstade spelare"},"de":{"votedplayers":"Gewählte Spieler"},"ko":{"votedplayers":"투표한 플레이어"}}')
  delete Component.options._Ctor
}
